import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from 'reselect';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody } from "reactstrap";
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import getChartColorsArray from '../../Components/Common/ChartsDynamicColor';
import ReactApexChart from "react-apexcharts";
import Preloader from '../../Components/Common/Preloader';
import { setClickByDeviceData, toggleClickModal } from '../../slices/analytics/reducer';
import DetailCard from './DetailCard';
import { getClickTable } from '../../slices/analytics/thunk';

function ClickByDevice() {
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState([]);
  const [labels, setLabels] = useState([]);
  const dataColors = ["--adc-primary", "--adc-warning", "--adc-info", "--adc-success", "--adc-danger", "--adc-orange"];

  const selectChartData = createSelector((state) => state,
    (state) => ({
      clickByDeviceLoader: state.Analytics.clickByDeviceLoader,
      clickByDeviceData: state.Analytics.clickByDeviceData,
      getClickByDevice: state.Analytics.getClickByDevice,
      analyticsCampaigns: state.Analytics.analyticsCampaigns
    }));

  const { clickByDeviceLoader, clickByDeviceData, getClickByDevice, analyticsCampaigns } = useSelector(selectChartData);

  function openClickByDevice() {
    dispatch(getClickTable(analyticsCampaigns));
  }

  useEffect(() => {
    if (clickByDeviceData && typeof clickByDeviceData === 'object') {
      if (Object.keys(clickByDeviceData).length !== 0) {
        setChartData(Object.values(clickByDeviceData));
        setLabels(Object.keys(clickByDeviceData));  
      } else {
        setChartData(['tv', 'ios', 'android', 'pc']);
        setLabels([0, 0, 0, 0]);
      }
    } else {
      setChartData([]);
      setLabels([]);
    }
  }, [clickByDeviceData]);

  return (
    <React.Fragment>
      {clickByDeviceLoader ?
        <Card className="card-height-100 align-items-center justify-content-center">
          <Preloader isComponentLoader={true} width={150} height={150} />
        </Card>
        : chartData.length >= 1 ?
          <Card className="card-height-100">
            <CardHeader className="align-items-center d-flex">
              <p className="mb-0 flex-grow-1">Clicks by Device</p>
              <div className="flex-shrink-0">
              </div>
            </CardHeader>
            <CardBody>
              <div dir="ltr">
                <UsersByDeviceCharts series={chartData} dataColors={JSON.stringify(dataColors)} labels={labels} />
              </div>
            </CardBody>
          </Card> :
          <DetailCard color='success'
            textColor='primary'
            avatar="bx bxs-devices"
            header="Device-Based Clicks Overview"
            text="Track the number of clicks by device type to gain insights into audience behavior and improve ad engagement across various platforms."
            onClick={openClickByDevice} />
      }
    </React.Fragment>
  )
}

export default ClickByDevice;

function UsersByDeviceCharts({ dataColors, series, labels = [] }) {
  var dountchartUserDeviceColors = getChartColorsArray(dataColors);
  const options = {
    labels: labels,
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: dountchartUserDeviceColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};
